import React, { useState } from 'react';
import useGlobalElementsService from '../../Hooks/useGlobalElementsService';
import { useMount } from 'react-use';
import { Media } from 'reactstrap';
import LinkedImage from '../../Models/CMS/LinkedImage';
import { sanitize } from '@ibe/services';

const Footer = () => {
  const cmsGlobalElementsService = useGlobalElementsService();
  const [footerText, setFooterText] = useState<string>('');
  const [footerImages, setFooterImages] = useState<LinkedImage[] | undefined>([]);

  useMount(() => {
    cmsGlobalElementsService.fetchGlobalElements().then(ge => {
      if (ge) {
        setFooterText(ge.footerText ?? '');
        setFooterImages(ge.footerImages);
      }
    });
  });

  if (!footerText && !footerImages) {
    return <></>;
  }

  return (
    <div className="footer__wrapper">
      <div className="footer">
        {footerImages && footerImages.length > 0 && (
          <div className="footer__logos">
            {footerImages.map((item, index) => {
              const logoImage = (
                <Media
                  src={item.image?.small?.url}
                  alt={item.image?.imageAlt ?? `logo-${index}`}
                  className="footer__logo-img"
                />
              );

              return item.href ? (
                <a
                  key={index}
                  href={item.href}
                  className="footer__logo-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {logoImage}
                </a>
              ) : (
                <div key={index} className="footer__logo-wrapper">
                  {logoImage}
                </div>
              );
            })}
          </div>
        )}

        {footerText && (
          <div
            className="footer__text"
            dangerouslySetInnerHTML={{
              __html: sanitize(footerText ?? '', true)
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Footer;
